import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import App from '@/App.vue';
// 主应用渲染函数
let app = null;

/**
 * 路由监听
 * @param {String} routerPrefix 路由前缀
 */
function genActiveRule (routerPrefix) {
    return location => location.pathname.startsWith(routerPrefix);
}

// /**
//  * 主应用渲染函数  使用qiankun2.0 版本，只需正常实例化vue即可
//  * @param appContent
//  * @param loading
//  * @returns {*}
//  */
// function vueRender () {
//     new Vue({
//         router,
//         store,
//         render: h => h(App)
//     }).$mount("#container");
//     return;
// };

/**
 * 主应用渲染函数  qiankun1.0 版本
 * @param appContent
 * @param loading
 * @returns {*}
 */
function render ({appContent, loading} = {}) {
    if (!app) {
        app = new Vue({
            el: '#container',
            router,
            store,
            data () {
                return {
                    content: appContent,
                    loading:loading
                };
            },
            render (h) {
                return h(App, {
                    props: {
                        content: this.content,
                        loading: this.loading
                    }
                });
            }
        });
    } else {
        app.content = appContent;
        app.loading = loading;
    }
}

export {
    genActiveRule, // 路由监听
    render // 主应用渲染函数
};